module.exports = __webpack_public_path__ + "static/media/qempo-lite-active.37e6a20b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shopping-cart/qempo-lite-active.png
// module id = 2276
// module chunks = 0